/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;
// PE-6153 — Chrome Permissions-Policy blocks document unload; do not let Zone.js patch it
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['unload', 'beforeunload'];
